import React from 'react';
import { useIntl } from 'react-intl';

import { FlexRow } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';

import { ImageTypes } from './contants';
import styles from './layout-image.module.css';

/**
 * @param {object} props - component props
 * @param {boolean} [props.showPackingSlip] - indicates if packing slip is displayed
 * @returns {JSX.Element}
 */
export const PortraitImage = ({ showPackingSlip = false }) => {
  const intl = useIntl();
  return (
    <FlexRow className={styles['images-container']}>
      <div className={styles.container}>
        <img alt={intl.formatMessage(ImageTypes.Label.text)} className={styles.image} src={ImageTypes.Label.image.portrait} />
        <div className={styles['text-container']}>
          <Text className={styles.text} textType={TextType.Caption} value={ImageTypes.Label.text} />
        </div>
      </div>

      {showPackingSlip ? (
        <div className={styles.container}>
          <img alt={intl.formatMessage(ImageTypes.PackingSlip.text)} className={styles.image} src={ImageTypes.PackingSlip.image.portrait} />
          <div className={styles['text-container']}>
            <Text className={styles.text} textType={TextType.Caption} value={ImageTypes.PackingSlip.text} />
          </div>
        </div>
      ) : null}
    </FlexRow>
  );
};
